import { render, staticRenderFns } from "./SysDepartRoleModal.vue?vue&type=template&id=419cc12a&scoped=true"
import script from "./SysDepartRoleModal.vue?vue&type=script&lang=js"
export * from "./SysDepartRoleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419cc12a",
  null
  
)

export default component.exports